import { makeStyles } from '@material-ui/styles'

function buttonStyles(mainColor, textColor, hoverColor) {
    const onHover = hoverColor
        ? {
              backgroundColor: hoverColor,
              boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
          }
        : {}
    return {
        '& .text': {
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'NotoSans',
            fontSize: '12px',
            fontWeight: 'bold',
            letterSpacing: '0.48px',
            color: textColor,
        },
        '&:hover': onHover,
        '& + div': {
            backgroundColor: hoverColor,
            width: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px',
            transform: 'translate(-5px, 0)', //TODO change this and parametrize main button borders
        },
        cursor: 'pointer',
        height: '40px',
        borderRadius: '2px',
        width: '212px',
        backgroundColor: mainColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'uppercase',
    }
}

export default makeStyles(({ colors }) => ({
    fixed: {
        '@media (max-width: 850px)': {
            width: '180px',
        },
    },
    primary: buttonStyles(colors.brand.pink, colors.text.light, '#c62742'),
    facebook: buttonStyles('#0e5496', colors.text.light, '#0c477e'),
    secondary: buttonStyles(colors.brand.blue, colors.text.light, '#2c53df'),
    tertiary: buttonStyles(colors.light.lightGray, colors.black, '#bec0c5'),
    white: buttonStyles(colors.white, colors.text.dark, '#bec0c5'),
    default: buttonStyles(colors.light.grey, colors.light.darkgrey, '#bec0c5'),
    outline: {
        ...buttonStyles(colors.white, '#000000', '#f7f9fc'),
        border: 'solid 1px #000000',
    },
    disabled: {
        ...buttonStyles(colors.light.grey, colors.light.darkgrey),
        cursor: 'auto',
    },
    container: {
        display: 'flex',
    },
    large: {
        height: '60px',
    },
    normal: {
        height: '40px',
    },
    block: {
        width: '100%',
    },
    inline: {
        width: 'auto !important',
        padding: '0 16px !important',
    },
    sideContent: {
        paddingLeft: '12px',
        paddingRight: '12px',
    },
    buttonContent: {
        height: 'inherit',
    },
}))
